import { useTranslation } from 'react-i18next';
import { IError } from 'types/interfaces/iError';

interface MachineErrorTooltipProps {
  error: IError;
}

const MachineErrorTooltip = ({ error }: MachineErrorTooltipProps) => {
  const { t } = useTranslation();

  return (error || {}).code || (error || {}).is_custom ? (
    <div>{error.is_custom ? error.message : `${error.code}: ${t(`dashboard.machines.error_codes.${error.code}`)}`}</div>
  ) : (
    ''
  );
};

export default MachineErrorTooltip;
